









import { Component, Mixins } from "vue-property-decorator";

// Mixins
import BrandMixin from "@/mixins/brandMixin";

@Component({
  components: {
    "revenue-report-listing": () =>
      import("@/components/app/admin/insights/revenueReportListing.vue")
  }
})
export default class MonthlyReportView extends Mixins(BrandMixin) {
  // Computed
  public get title() {
    return this.$t("_.reports.monthly_report_in_brand_currency", {
      brandCurrency: this.brandCurrencyName
    });
  }
}
